"use strict";
require("./parsers/index.js");
require("./types.js");
//# sourceMappingURL=index.js.map
